import React from 'react';

import { AddIcon } from '../icons';

import { useStyles } from './AddAsset.styles';

export const AddAsset = ({ onClick }: { onClick: () => void }) => {
  const { container, icon } = useStyles();

  return (
    <div data-testid="addAsset" onClick={onClick} className={container}>
      <AddIcon className={icon} />
    </div>
  );
};
